import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import RenunciaReceitaService from '../../../services/renunciaReceita'
import Renuncia from './renuncia';

const ListarRenuncias = () => {


    const [renuncias, setRenuncias] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchRenuncias() {
        const response = await RenunciaReceitaService.listar();
        if (response.data.length >= 1) {
            setRenuncias(response.data)
            setVazio(false)
        } else {
            setRenuncias([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchRenuncias();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setRenuncias={setRenuncias}
                    setVazio={setVazio}
                    fetchRenuncias={fetchRenuncias}
                    renuncias={renuncias}
                />
            </Fragment>
            {vazio ? <Fragment>
                <Alert variant='danger'>Nenhuma renúncia de receita ou desoneração fiscal foi realizada até o dado momento no Município de Macuco.</Alert>
            </Fragment> :
                <Fragment>
                    <h5>Renúncias de Receita no Município de Macuco:</h5><br />
                    <Row xs={12} lg={3}>
                        {renuncias.map((renuncia, index) =>
                            <Renuncia
                                renuncia={renuncia}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarRenuncias;